import inboxRuleStore from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * Set the selectedFolderId in inbox rule store
 * @param folderId the folderId to set
 * @param state the state which contains the inbox rule store
 */
export default action('setInboxRuleSelectedFolderId')(select({
    inboxRuleStore: function () { return inboxRuleStore; },
})(function setInboxRuleSelectedFolderId(folderId, state) {
    state.inboxRuleStore.selectedFolderId = folderId;
}));
//# sourceMappingURL=setInboxRuleSelectedFolderId.js.map